import React from 'react'
import Image from '../../../images/sellerpolicies/5.png'

const Data_collection_from_seller = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>DATA COLLECTION FROM SELLER</h2>
            <p>We collect your data when you register to KAAY as a user or business. We use your data so that you can use the Service and, from time to time, we may use your data to comply with our legal obligations or for other legitimate reasons. There may also be times when we ask for your consent to use your data. KAAY collect data from you when you use our platform or when you provide it to us, for example when you:</p>
            <ul>
              <li>a.	Register to use the platform.</li>
              <li>b.	List an item for sale or sell or buy an item.</li>
              <li>c.	View, like, save, search for or comment on an item, or communicate with other users.</li>
              <li>d.	Instant messages between seller and buyer.</li>
              <li>e.	Sign up for our marketing emails and push notifications.</li>
              <li>f.	At order fulfillment and delivery.</li>
              <li>g.	Complete a form or survey.</li>
              <li>h.	Enter a competition or take part in a promotion.</li>
            </ul>
            <p>We may also collect and use your data if we:</p>
            <ul>
                <li>a.	Are legally required.</li>
                <li>b.	Have your consent.</li>
                <li>c.	Have a legitimate reason to do so in a way that might reasonably be expected as part of running our business (known as a legitimate interest), as long as your interests and fundamental rights do not take priority over our legitimate reasons.</li>
                <li>d.	We collect your content, which may feature images containing your personal data when you voluntarily submit it to us when using the platform. We may use your content and/or images in our online and offline marketing campaigns, which may be conducted via third parties on our behalf.</li>
            </ul>
            <p>In-App Messages, Comments, and Item Descriptions</p>
            <p>If you send in-app messages or comments or provide item descriptions, we may access, store and review these:</p>
            <ul>
                <li>a.	To help with fulfilling an order made via our Service.</li>
                <li>b.	To respond to issues, concerns, queries, or disputes raised by users and to resolve disputes.</li>
            </ul>
        </div>
      </div>
    </div>
  )
}

export default Data_collection_from_seller
